export default function Stats() {
  const stats = [
    { number: '15+', label: 'Years Experience', icon: 'ri-time-line' },
    { number: '5000+', label: 'Happy Customers', icon: 'ri-user-smile-line' },
    { number: '24/7', label: 'Emergency Service', icon: 'ri-phone-line' },
    { number: '100%', label: 'Satisfaction Rate', icon: 'ri-star-line' }
  ];

  return (
    <section className="py-14 md:py-24 bg-gradient-to-br from-[#535669] to-[#3a3b4a] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="w-12 h-12 md:w-16 md:h-16 bg-[#f67f19]/20 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                <i className={`${stat.icon} text-[#f67f19] text-2xl md:text-3xl`}></i>
              </div>
              <div className="text-3xl md:text-4xl lg:text-6xl font-black text-white mb-1 md:mb-2">
                {stat.number}
              </div>
              <div className="text-xs md:text-sm lg:text-base text-white/80 font-semibold">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}